import React from 'react';
import { useTranslation } from 'next-i18next';
import useWindowSize from '@hooks/use-window-size';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { ROUTER_QUERY_KEY } from '@hooks/orders-sales/use-query-tab';
import { State } from './type';
import styles from './products.module.scss';
import { getCurrentProduct, updateURLQueries } from './helper';
import SalesView from './sales/sales';
import OrdersView from './orders/orders';

const TabView: React.FC<{
  state: State;
  updateState: (s: State) => void;
}> = ({ state, updateState }) => {
  const router = useRouter();

  const { t } = useTranslation('orders-sales');
  const { currentTab } = state;
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');

  const emptyBookmark = {
    orderId: '',
    productId: '',
  };

  const handleOrderClick = () => {
    updateState({
      ...state,
      currentTab: 'Order',
    });
    updateURLQueries(router.pathname, { section: ROUTER_QUERY_KEY.order, ...emptyBookmark });
    sendAnalyticEvent('timeline_orders', {});
  };

  const handleSaleClick = () => {
    updateState({
      ...state,
      currentTab: 'Sale',
    });
    updateURLQueries(router.pathname, { section: ROUTER_QUERY_KEY.sale, ...emptyBookmark });
    sendAnalyticEvent('timeline_sales', {});
  };

  return (
    <div className={styles.ordersSales__mainLeft__tabs}>
      <button
        className={styles.ordersSales__mainLeft__tabs__tab}
        onClick={handleOrderClick}
      >
        <div
          className={clsx(
            styles.ordersSales__mainLeft__tabs__tab__inner,
            currentTab === 'Order' ? styles['ordersSales__mainLeft__tabs__tab--active'] : '',
          )}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.LIST.ORDERS')}
        </div>
      </button>
      <button
        className={styles.ordersSales__mainLeft__tabs__tab}
        onClick={handleSaleClick}
      >
        <div
          className={clsx(
            styles.ordersSales__mainLeft__tabs__tab__inner,
            currentTab === 'Sale' ? styles['ordersSales__mainLeft__tabs__tab--active'] : '',
          )}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.LIST.SALES')}
        </div>
      </button>
    </div>
  );
};

const View: React.FC<{
  state: State;
  updateState: (s: State) => void;
}> = ({ state, updateState }) => {
  const { isWiderThanMd } = useWindowSize();

  const negLeft = !isWiderThanMd && getCurrentProduct(state) != null ? 'ordersSales__mainLeft--neg' : '';

  return (
    <div className={clsx(styles.ordersSales__mainLeft, styles[negLeft])}>
      <TabView
        state={state}
        updateState={updateState}
      />

      <div className={styles.ordersSales__mainLeft__wrapper}>
        {state.currentTab === 'Order' && (
          <OrdersView
            state={state}
            updateState={updateState}
          />
        )}
        {state.currentTab === 'Sale' && (
          <SalesView
            state={state}
            updateState={updateState}
          />
        )}
      </div>
    </div>
  );
};

export default View;
